import React from "react";
import { Button, Container, Grid, Typography, Link } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import mapIcon from "../../images/map.svg";
import mruLogo from "../../images/mruLogo.png";
import styles from "./styles";

const HomeScreen = ({ classes, setCurrentScreen }) => {
  const handleClick = () => setCurrentScreen("Quiz");

  return (
    <Grid container className={classes.homeMainScreenContainer}>
      <Grid container className={classes.homeScreenContainer}>
        <Container maxWidth="md">
          <Typography align="center" className={classes.homeTitle}>
            ECON PRACTICE
          </Typography>
          <Grid container justify="center">
            <img src={mapIcon} className={classes.gdpIcon} />
          </Grid>
          <Typography align="center" className={classes.homeQuestion}>
            What's Included in U.S. GDP? (Set 1/2)
          </Typography>
          <Grid container justify="center">
            <Button className={classes.playButton} onClick={handleClick}>
              play
            </Button>
          </Grid>
        </Container>
      </Grid>
      <Grid container className={classes.mruLogoContainer}>
        <Grid container justify="flex-end">
          <Link
            href="https://mru.org"
            target="_blank"
            className={classes.mruLogo}
          >
            <img src={mruLogo} className={classes.logoImg} />
          </Link>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(HomeScreen);
